export const portalData = {
  // Fax Details
  hasFax: false,
  faxNo: "",
  
  // Whatsapp details
  hasWhatsApp: true,
  whatsAppNo: "+60102009648",
  whatsAppNoHolderName: "Daven",
  hasAltWhatsApp: false,
  altWhatsAppNo: "",
  altWhatsAppNoHolderName: "",
  hasAltWhatsApp1: false,
  altWhatsAppNo1: "",
  altWhatsAppNoHolderName1: "",
  hasAltWhatsApp2: false,
  altWhatsAppNo2: "",
  altWhatsAppNoHolderName2: false,
  
  // Phone number details
  hasPhoneNo: true,
  phoneNo: true,
  hasAltPhoneNo: true,
  altPhoneNo: true,
  
  // Telephone number details
  hasTellNo: true,
  tellNo: "+6014-8081111",
  tellNoHolderName: "",
  hasAltTellNo: false,
  altTellNo: "",
  altTellNoHolderName: "",
  hasAltTellNo2: false,
  altTellNo2: "",
  altTellNoHolderName2: "",
  
  // Portal information details
  portalName: "The One Premium Tour",
  portalFullName: "The One Premium Tour & Adventure SDN. BHD. (1097628-P)(Formerly known as Sipadan Eco Tour & Adventure Sdn. Bhd.)",
  portalShortAddress: "C-0-9 Kuchai Business Park",
  portalAddress: "C-0-9 Kuchai Business Park,  NO. 2 Jalan 1/127, Off Jalan Kuchai Lama, Kuala Lumpur,  W.P",
  portalAddressFirstPart: "C-0-9 Kuchai Business Park, NO. 2 Jalan 1/127, Off Jalan Kuchai Lama",
  portalAddressSecondPart: " Kuala Lumpur,  W.P",
  portalAddressDetails: "C-0-9 Kuchai Business Park,  NO. 2 Jalan 1/127, Off Jalan Kuchai Lama, Kuala Lumpur,  W.P",
  hasPortalRegNo: false,
  portalRegNo: "",
  
  // Portal Bank Details
  portalBankName: "AM Bank",
  portalBankAddress: "4 & 6, JALAN PUTERI 1/1, BANDAR PUTERI, 47100 PUCHONG, SELANGOR, MALAYSIA",
  portalBankAccHolderName: "THE ONE PREMIUM TOUR & ADVENTURE SDN. BHD. (1097628-P)(Formerly known as Sipadan Eco Tour & Adventure Sdn. Bhd.)",
  portalBankAccNo: "8881058307173",
  hasPortalBankSwiftCode: true,
  portalBankSwiftCode: "ARBKMYKL",
   
  portalEmail: "theonetenggolresort@gmail.com",
  portalTermAndCondUrl: process.env.REACT_APP_PORTAL_TERM_AND_COND_URL,
   
  // GST details
  hasGst: false,
  gstNo: true,
   
  // Website
  portalWebsite: process.env.REACT_APP_PORTAL_WEBSITE,
 
  // Travoxis Website
  travoxisWebsite: process.env.REACT_APP_TRAVOXIS_WEBSITE,
 
  // Facebook page link
  facebookMessengerLink: "https://www.facebook.com/theonetenggolislandresort",
 
  // portal S3 base url
  s3AwsUrl: "",
 
  adminPortalUrl: process.env.REACT_APP_ADMIN_PORTAL_URL,

  // Portal Jetty names
  jettyOne: "A’King Jetty",
  jettyTwo: "The One Premium Tour & Adventure SDN. BHD.",
  jettyThree: "",
  jettyOneToTwoTime: "11:00 AM",
  jettyTwoToOneTime: "09:30 AM"
}